import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

import {
  REQUEST_NOTIFICATIONS,
  RECEIVE_NOTIFICATIONS
} from '../actions/notifications'

export default handleActions({
  [REQUEST_NOTIFICATIONS]: (state, action) => ({isFetching: true}),
  [RECEIVE_NOTIFICATIONS]: (state, action) => {
    const { total_unseen, notifications } = action.payload.data

    return {
      total_unseen,
      items: notifications
    }
  }
}, {})



// WEBPACK FOOTER //
// ./src/reducers/notifications.js